import { render, staticRenderFns } from "./DatasourceSelect.vue?vue&type=template&id=b2a01d74&"
import script from "./DatasourceSelect.vue?vue&type=script&lang=js&"
export * from "./DatasourceSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports